import { GetBounds } from "./GetBounds";

/**
 * Get goubds of all items in collection
 * @uses @see GetBounds
 * @param go 
 * @returns 
 */
 export function GetBoundsCollection(
    views: any | any[],
    extrude: number = 0
): Phaser.Geom.Rectangle
{
    let area: Phaser.Geom.Rectangle = GetBounds(views[0], extrude);
    // console.log("area0("+views[0].name+"):",area);
    if (views.length > 1) {
        for (let i = 1; i<views.length; i++) {
            const viewBounds = GetBounds(views[i], extrude);
            // console.log("area"+i+"("+views[i].name+"):",viewBounds);
            Phaser.Geom.Rectangle.Union(area, viewBounds, area);
        }
    }
    // console.log("total area:",area);
    return area;
}